import { render, staticRenderFns } from "./doctors.vue?vue&type=template&id=e23f8ed0&scoped=true"
import script from "./doctors.vue?vue&type=script&lang=js"
export * from "./doctors.vue?vue&type=script&lang=js"
import style0 from "./doctors.vue?vue&type=style&index=0&id=e23f8ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f8ed0",
  null
  
)

export default component.exports